import { useEffect } from "react";
import { Users } from "lucide-react";
import { useQueryState } from "nuqs";
import { FriendsTab, FRIENDS_TABS } from "./types/friends.types";
import { useFriendsStore } from "./store/useFriendsStore";
import FriendsTabView from "./components/FriendsTab";
import SplitGroupsTab from "./components/SplitGroupsTab";

export default function FriendsPage() {
  const loadFriends = useFriendsStore((s) => s.loadFriends);

  const [tab, setTab] = useQueryState<FriendsTab>("tab", {
    defaultValue: FriendsTab.Friends,
    parse: (v: string): FriendsTab =>
      Object.values(FriendsTab).includes(v as FriendsTab)
        ? (v as FriendsTab)
        : FriendsTab.Friends,
  });

  useEffect(() => {
    void loadFriends();
  }, [loadFriends]);

  return (
    <>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-9 h-9 shrink-0 rounded-xl bg-primary/10 flex items-center justify-center">
          <Users className="w-5 h-5 text-primary" />
        </div>
        <div className="min-w-0">
          <h1 className="text-xl font-bold text-foreground">Friends</h1>
          <p className="text-sm text-muted-foreground">
            The people you split bills with, and your split groups
          </p>
        </div>
      </div>

      <div className="mb-6 flex gap-1 border-b border-border" role="tablist">
        {FRIENDS_TABS.map(({ id, label }) => (
          <button
            key={id}
            role="tab"
            aria-selected={tab === id}
            onClick={() => void setTab(id)}
            className={`min-h-11 px-4 text-sm font-medium border-b-2 -mb-px transition-colors ${
              tab === id
                ? "border-primary text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === FriendsTab.Friends && <FriendsTabView />}
      {tab === FriendsTab.Groups && <SplitGroupsTab />}
    </>
  );
}
